import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="mx-auto flex w-full max-w-[1240px] flex-col items-center px-4 text-center md:px-6">
        <span className="font-label text-7xl font-semibold text-background-300 md:text-9xl">404</span>
        <span className="mt-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-700" aria-hidden="true">
          <i className="ri-compass-3-line text-2xl" />
        </span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这个页面没有找到
        </h1>
        <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-600">
          你访问的地址可能已经调整或不存在。可以返回首页，或直接去事件案例库看看正在追踪的信息。
        </p>
        <p className="mt-2 text-xs text-foreground-400">当前路径：{location.pathname}</p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line text-base" aria-hidden="true" />
            <span className="whitespace-nowrap">返回首页</span>
          </Link>
          <Link
            to="/cases"
            className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-stack-line text-base" aria-hidden="true" />
            <span className="whitespace-nowrap">浏览事件案例库</span>
          </Link>
        </div>
      </div>
    </section>
  );
}